import { ChatDotsIcon } from '@phosphor-icons/react';
import { Button } from '@atoms/Button/Button';

export const WebAssistant = ({
  enableAssistant,
}: {
  enableAssistant: boolean;
}) => {
  return enableAssistant ? (
    <>
      <hr className="my-6 border-[#475372]" />
      <p className="text-bodyLg text-text-body mb-6">
        Find information and get support quickly
        <br />
        online using our web assistant.
      </p>
      <Button
        label="Chat with our web assistant"
        href="#"
        variant="primary"
        iconLeft={<ChatDotsIcon />}
      />
    </>
  ) : null;
};
